// A document whose job is running cannot be deleted: the job would go on writing its transcript,
// passages and entities for a document nothing could remove them through any more. The API refuses
// such a delete with 409 `document_in_flight` (a capture's refusal carries a code of its own and
// has its wording in `capture-integrity.ts`); this helper lets the document list say why.
import type { TFunction } from 'i18next'
import { ApiError } from '@/services/api/client'

/** The code of the refusal, in the answer's `detail`. */
const IN_FLIGHT_CODE = 'document_in_flight'

/** Whether a 409's `detail` says the document is still being processed. */
function saysInFlight(detail: unknown): boolean {
  // An older server said it in a plain message: the only delete it refused without a code.
  if (typeof detail === 'string') return true
  return (detail as { code?: unknown } | null | undefined)?.code === IN_FLIGHT_CODE
}

/** The translated reason a delete was refused because a document is still being processed; null for any other failure. */
export function inFlightRefusal(error: unknown, t: TFunction): string | null {
  if (!(error instanceof ApiError) || error.status !== 409) return null
  const detail = (error.data as { detail?: unknown } | null | undefined)?.detail
  return saysInFlight(detail) ? t('documents.inFlight.deleteRefused') : null
}
